import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, Subject } from 'rxjs';
import { layout } from '@app-styles/styles-contants';
import { MediaWatcherHelperService } from '@app/core/services/media-watcher-helper.service';
import { select, Store } from '@ngrx/store';
import * as fromApp from '@app/store/app.reducers';
import { selectHideMainMenu } from '@app/settings/store/settings.selectors';
import { tap } from 'rxjs/operators';
import { StatusMessage } from '@app/store/layout/layout.model';
import { LocalStorageService } from '@app/core/local-storage/local-storage.service';
import { STATUS_MESSAGE_LOCALSTORAGE_KEY } from '@app/constants/application-constants';

@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit, OnDestroy, AfterViewInit {

    private destroy$ = new Subject<void>();
    hideMainMenu: boolean;
    hideFooter: boolean;
    isDesktop = true;
    isMobile = false;
    isMobileMenuVisible = false;
    statusMessage = null;

    handleIsLarge(matches) {
        if (matches) {
            this.isDesktop = true;
            this.isMobile = false;
            this.isMobileMenuVisible = false;
        } else {
            this.isDesktop = false;
            this.isMobile = true;
            this.isMobileMenuVisible = false;
        }
    }

    openMobileMenu(): void {
        this.isMobileMenuVisible = true;
    }

    closeMobileMenu(): void {
        this.isMobileMenuVisible = false;
    }

    initHideMainMenu() {
        this.store.pipe(
            select(selectHideMainMenu),
            // use setTimeout to prevent expression change error
            tap(hide => setTimeout(() => this.hideMainMenu = hide, 0))
        ).subscribe();
    }

    constructor(
        private store: Store<fromApp.AppState>,
        private mediaWatcherHelper: MediaWatcherHelperService,
        private cdr: ChangeDetectorRef,
        private localStorageService: LocalStorageService,
    ) {
    }

    ngOnInit() {
        this.hideFooter = !!environment['hideFooter'];
        this.initHideMainMenu();

        this.store.pipe(
            select(fromApp.getStatusMessage),
            tap((statusMessage: StatusMessage) => {
                const closedMessage = this.localStorageService.getItem(STATUS_MESSAGE_LOCALSTORAGE_KEY);
                if (closedMessage) {
                    const decodedMessage = btoa(JSON.stringify(statusMessage));
                    if (closedMessage === decodedMessage) {
                        return;
                    }
                }
                if (statusMessage && statusMessage.type === 'Warning') {
                    this.statusMessage = statusMessage;
                }
            })
        ).subscribe();
    }

    ngAfterViewInit(): void {
        const { desktop: query } = layout;
        const callback = this.mediaWatcherHelper.buildWatcher(query, this.handleIsLarge.bind(this), this.cdr);
        this.mediaWatcherHelper.registerListener(callback, this.destroy$);

    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
    onStatusMessageClose(): void {
        const statusMessage = JSON.stringify(this.statusMessage);
        this.localStorageService.setItem(STATUS_MESSAGE_LOCALSTORAGE_KEY, btoa(statusMessage));
        this.statusMessage = null;
    }
}
